import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=b916bb58&scoped=true"
var script = {}
import style0 from "./Home.vue?vue&type=style&index=0&id=b916bb58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b916bb58",
  null
  
)

export default component.exports